import { getDocument } from '~/components/AnalyzerResultsPage/AnalyzerResultsPage.data';
import { pilot } from '~/services/serviceInstances';

export const getRecentlyViewed = () => pilot.get('document/recently-viewed/');

export const searchDocuments = (query) => getDocument({ query }, null, 1, 10);
